import React from 'react';
import Button from "../button";
import OverlayIndicator from "../General/overlayIndicator";
import {Link} from "react-router-dom";
import Pagination from "../pagination";
import moment from "moment";
import FormGroupSelectInput from "../formGroupSelectInput";
import {CUSTOM_AUTOSUGGEST_INPUT_STYLE, POLICYHOLDER_TEXT, TABLE_VIEW_OPTIONS} from "../../helpers/variables";
import Autosuggest from "react-autosuggest";
import SearchIcon from "../icons/searchIcon";
import MultiSelectInput from '../General/multiSelectInput';
import { FormGroup } from 'arag-ui-lib';

const url = '/quote/';

const tableHeaders = [
    {name: 'Quote Reference', key: 'quoteReference', sortable: false},
    {name: `${POLICYHOLDER_TEXT} Name`, key: 'clientName', sortable: false},
    {name: 'Broker Name', key: 'brokerName', sortable: false},
    {name: 'Broker Postcode', key: 'brokerPostcode', sortable: false},
    {name: 'Date Modified', key: 'dateModified', sortable: false},
    {name: 'Status', key: 'status', sortable: false},
];

const Quotes = (props) => {
    const { quotes, history, changeQuotesListPage, quotesListPageShift,  page, totalPaginationBoxes, viewAmount,
         totalRecords, changeQuotesState, quoteStatuses, quoteStatus, suggestions, onSuggestionsFetchRequested,
        onSuggestionsClearRequested, getSuggestionValue, renderSuggestion, autoSuggestInputProps, onSuggestionSelected,
        _handleAutoSuggestIconClick, submitListFilters, fetchingQuotes,postcodeOptions,quoteStatusesOptions} = props;
    return (
        <div className={'mb-15'}>
            <div className={'row'}>
                <h2 className="col-sm-12 applicationsAndPolicies-h2">Quotes</h2>
            </div>
            <div className={'row'}>
                <div className={'col-sm-12'}>
                    <Button
                        clickHandler={() => history.push('/quote')}
                        wrapper="btn-wrapper"
                        btnType="button"
                        btnStyle={'btn btn-primary btn-xs sharp yellow'}
                        label="Create New Quote"/>
                </div>
            </div>
            <div className={'row mt-15'}>
                <div className={'col-sm-12'}>
                    <form className={'form-horizontal'} onSubmit={submitListFilters}>

                        <FormGroup
                            labelSize={"col-xs-2"}
                            inputSize={"col-xs-7"}
                            label={"Broker name"}
                            variant={"searchableList"}
                            inputProps={{
                                inputValue: props.brokerFilterSearchValue,
                                onInputChange: (value) => {
                                    props.changeQuotesState({ key: 'brokerFilterSearchValue', value: value });
                                },
                                onChange: (value) => {
                                    props.changeQuotesState({ key: 'selectedBrokerFirms', value: value });
                                }, //value holds all the existing selections
                                instanceId: 'brokerfirm',
                                value: props.selectedBrokerFirms.map(l => ({ value: l.value, label: l.label })),
                                options: [...props.selectedBrokerFirms.map(l => ({ value: l.value, label: l.label })),
                                ...props.brokerFirmsFiltered.map(b => ({ value: b.id, label: b.name }))],
                                isLoading: props.fetchingBrokers,
                                placeholder: 'Type at least 3 letters',
                                noOptionsText: `No Brokers found`,
                                minSearchCharacters: 3,
                                isMulti: true,
                            }}
                        />

                        <FormGroup
                            labelSize={'col-sm-2'}
                            inputSize={'col-sm-7'}
                            label={'Status'}
                            variant={'multiSelect'}
                            inputProps={{
                                options: quoteStatusesOptions,
                                onChange: (evt) => props.handleStatusFilterChange(evt),
                                value: props.selectedStatuses,
                                isLoading: false,
                                instanceId: 'statuses',
                                isDisabled: false,
                                required: false,
                            }}
                        />

                        <FormGroup
                            labelSize={'col-sm-2'}
                            inputSize={'col-sm-7'}
                            label={'Broker Postcode'}
                            variant={'multiSelect'}
                            inputProps={{
                                options: postcodeOptions,
                                onChange: (evt) => props.handleBrokerPostcodeFilterChange(evt),
                                value: props.selectedPostcodes,
                                isLoading: false,
                                instanceId: 'postcodes',
                                isDisabled: false,
                                required: false,
                            }}
                        />
                        <div className={'form-group'} style={{display:'flex',alignItems:'baseline'}} >
						<div className="col-sm-2">
							<label className={'control-label.text-left formGroupSelectInput-label'}>
								{"Search"}
							</label>
						</div>
                            <div className={'col-sm-7'} onKeyPress={evt => {
                                if(evt.key === 'Enter'){ _handleAutoSuggestIconClick() }
                            }}>
                                <Autosuggest
                                    suggestions={suggestions}
                                    onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                                    onSuggestionsClearRequested={onSuggestionsClearRequested}
                                    getSuggestionValue={getSuggestionValue}
                                    renderSuggestion={renderSuggestion}
                                    inputProps={autoSuggestInputProps}
                                    onSuggestionSelected={onSuggestionSelected}
                                    theme={CUSTOM_AUTOSUGGEST_INPUT_STYLE}
                                />
                                <div className="applicationsAndPolicies-autosuggest-search-icon"
                                     onClick={_handleAutoSuggestIconClick}
                                     style={{paddingLeft:2,paddingTop:2,width:34,height:36}}
                                >
                                    <SearchIcon />
                                </div>
                            </div>
                        </div>
                        <div className={'form-group'}>
                        <div className={'col-sm-6 col-sm-offset-2'}>
                            <Button
								clickHandler={props.handleFilterClick} wrapper="btn-wrapper"
								btnType="button" btnStyle={'btn btn-primary btn-xs sharp yellow'}
								label="Filter"
							/>
                            <Button
								clickHandler={props.handleClearFiltersClick} wrapper="btn-wrapper"
								btnType="button" btnStyle={'btn btn-primary btn-xs sharp white'}
								label="Clear filters"
							/>
                        </div>
                    </div>



                    <div className={'col-sm-2'}>
                                <FormGroupSelectInput
                                    Value={viewAmount}
                                    Label='View'
                                    LeftWrapper="col-sm-5"
                                    Options={TABLE_VIEW_OPTIONS}
                                    HandleInputChange={evt => changeQuotesState({
                                        key:'viewAmount',
                                        value: evt.target.value
                                    })}
                                    CenterWrapper="col-sm-7 formGroupSelectInput-select-wrapper"
                                    RightWrapper=""
                                    SelectStyle={'form-control formGroupSelectInput-select'}
                                />
                            </div>
                    </form>
                </div>
            </div>
            <div className={'row'}>
                <div className={'col-sm-12 table-wrapper__arag'}>
                    <table className={'table'}>
                        <caption style={{padding: '0px'}}>
                            <OverlayIndicator fetching={fetchingQuotes}/>
                        </caption>
                        <thead>
                        <tr>
                            {tableHeaders.map((column, index) => (
                                <th key={index}>
                                    {column.name}
                                </th>
                            ))}
                        </tr>
                        </thead>
                        <tbody>
                        {quotes.map((quote, index) => (
                            <tr key={index} className={'table-link-row'}>
                                <td className="table-link-row__link-cell" style={{verticalAlign: 'middle'}} >
                                    <Link to={url + quote.id} >
                                        {quote.aragReference}
                                    </Link>
                                </td>
                                <td className="table-link-row__link-cell" style={{verticalAlign: 'middle'}} >
                                    <Link to={url + quote.id} >
                                        {quote.clientName}
                                    </Link>

                                </td>
                                <td className="table-link-row__link-cell" style={{verticalAlign: 'middle'}} >
                                    <Link to={url + quote.id} >
                                        {quote.firmName}
                                    </Link>

                                </td>
                                <td className="table-link-row__link-cell" style={{verticalAlign: 'middle'}} >
                                    <Link to={url + quote.id} >
                                        {quote.agentPostcode}
                                    </Link>

                                </td>
                                <td className="table-link-row__link-cell" style={{verticalAlign: 'middle'}} >
                                    <Link to={url + quote.id} >
                                        {moment(quote.lastEditedAt).format('DD/MM/YYYY HH:mm:ss')}
                                    </Link>

                                </td>
                                <td className="table-link-row__link-cell" style={{verticalAlign: 'middle'}} >
                                    <Link to={url + quote.id} >
                                        {quote.policyStatus}
                                    </Link>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <Pagination
                PageShift={quotesListPageShift}
                HandleInputChange={(name, value) => changeQuotesListPage({value: value})}
                TotalDisplayBoxes={totalPaginationBoxes}
                TotalRecords={totalRecords}
                Page={page}
                SelectedView={parseInt(viewAmount)}
                DataLength={20}
            />
        </div>
    )
};

export default Quotes;
